import { FormRow, BigFormRow } from 'framework/ui/layout';
import { TextInput, DateInput, TextArea } from 'framework/form';
import { AttachmentUploaderInput } from 'domain/shared/artifact/input';
import AssignmentLanguageDropdown from 'domain/people/employee/assessment/shared/input/AssignmentLanguageDropdown';

const AssessmentForm = () => (
  <>
    <FormRow colXl={4}>
      <TextInput source="assessorName" label="Assessor" />
      <AssignmentLanguageDropdown source="assignmentLanguage" label="Language" />
      <TextInput source="levelAssignment" label="Formal level assignment" />
      <DateInput label="Assessment date" source="assessmentDate" />
    </FormRow>
    <BigFormRow>
      <TextArea source="feedbackDetails" label="Feedback details" />
    </BigFormRow>
    <BigFormRow>
      <AttachmentUploaderInput label="Document scans" source="filesIds" />
    </BigFormRow>
  </>
);

export default AssessmentForm;
